var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("hb-section", { staticClass: "campaign-card" }, [
    _c(
      "div",
      { staticClass: "campaign-card__head" },
      [
        _c("div", { staticClass: "campaign-card__identity" }, [
          _c("div", { staticClass: "campaign-card__name" }, [
            _vm._v(_vm._s(_vm.campaignName(_vm.participation))),
          ]),
          _c("div", { staticClass: "campaign-card__entity" }, [
            _vm._v(_vm._s(_vm.entityLine(_vm.participation))),
          ]),
        ]),
        _vm.endingSoon
          ? _c("b-badge", { attrs: { variant: "light-warning" } }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("influencer_panel.ends_in_days", {
                      days: _vm.participation.days_to_end,
                    })
                  ) +
                  " "
              ),
            ])
          : _c("hb-status-badge", {
              attrs: {
                status: _vm.participation.status,
                domain: "participation",
              },
            }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "campaign-card__earned" },
      [
        _c("span", { staticClass: "campaign-card__earned-label" }, [
          _vm._v(_vm._s(_vm.$t("influencer_panel.you_earned"))),
        ]),
        _c("hb-money", {
          attrs: {
            cents: _vm.metric("commission_cents"),
            size: "lg",
            tone: "brand",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "campaign-card__metrics" }, [
      _c("div", { staticClass: "campaign-card__metric" }, [
        _c("div", { staticClass: "campaign-card__metric-label" }, [
          _vm._v(_vm._s(_vm.$t("influencer_panel.commission"))),
        ]),
        _c("div", { staticClass: "campaign-card__metric-value" }, [
          _vm._v(_vm._s(_vm.commissionLabel(_vm.participation))),
        ]),
      ]),
      _c("div", { staticClass: "campaign-card__metric" }, [
        _c("div", { staticClass: "campaign-card__metric-label" }, [
          _vm._v(_vm._s(_vm.$t("influencer_panel.sales"))),
        ]),
        _c("div", { staticClass: "campaign-card__metric-value" }, [
          _vm._v(_vm._s(_vm.metric("conversions"))),
        ]),
      ]),
      _c("div", { staticClass: "campaign-card__metric" }, [
        _c("div", { staticClass: "campaign-card__metric-label" }, [
          _vm._v(_vm._s(_vm.$t("influencer_panel.clicks"))),
        ]),
        _c("div", { staticClass: "campaign-card__metric-value" }, [
          _vm._v(_vm._s(_vm.metric("clicks").toLocaleString("pt-BR"))),
        ]),
      ]),
      _c("div", { staticClass: "campaign-card__metric" }, [
        _c("div", { staticClass: "campaign-card__metric-label" }, [
          _vm._v(_vm._s(_vm.$t("influencer_panel.conversion_rate"))),
        ]),
        _c("div", { staticClass: "campaign-card__metric-value" }, [
          _vm._v(_vm._s(_vm.conversionRate)),
        ]),
      ]),
    ]),
    _vm.participation.period_elapsed_pct !== null
      ? _c("div", { staticClass: "campaign-card__period" }, [
          _c("div", { staticClass: "campaign-card__period-row" }, [
            _c("span", [_vm._v(_vm._s(_vm.periodRange))]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("influencer_panel.period_elapsed", {
                    percent: _vm.participation.period_elapsed_pct,
                  })
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "campaign-card__bar" }, [
            _c("div", {
              staticClass: "campaign-card__bar-fill",
              style: { width: _vm.participation.period_elapsed_pct + "%" },
            }),
          ]),
        ])
      : _vm._e(),
    _vm.participation.coupon_code
      ? _c(
          "div",
          { staticClass: "campaign-card__coupon" },
          [
            _c("feather-icon", { attrs: { icon: "TagIcon", size: "14" } }),
            _c("code", { staticClass: "campaign-card__coupon-code" }, [
              _vm._v(_vm._s(_vm.participation.coupon_code)),
            ]),
            _vm.couponDiscount
              ? _c("span", { staticClass: "campaign-card__coupon-discount" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("influencer_panel.coupon_discount", {
                          discount: _vm.couponDiscount,
                        })
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c("hb-copy-button", {
              staticClass: "ml-auto",
              attrs: {
                text: _vm.participation.coupon_code,
                "allow-share": false,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "campaign-card__actions" },
      [
        _c(
          "b-button",
          {
            attrs: { variant: "primary", size: "sm" },
            on: {
              click: function ($event) {
                return _vm.$emit("generate-link", _vm.participation)
              },
            },
          },
          [
            _c("feather-icon", {
              staticClass: "mr-50",
              attrs: { icon: "Link2Icon", size: "14" },
            }),
            _vm._v(
              " " + _vm._s(_vm.$t("influencer_panel.generate_link")) + " "
            ),
          ],
          1
        ),
        _c(
          "b-button",
          {
            attrs: { variant: "outline-secondary", size: "sm" },
            on: {
              click: function ($event) {
                return _vm.$emit("material", _vm.participation)
              },
            },
          },
          [
            _c("feather-icon", {
              staticClass: "mr-50",
              attrs: { icon: "ImageIcon", size: "14" },
            }),
            _vm._v(" " + _vm._s(_vm.$t("influencer_panel.material")) + " "),
          ],
          1
        ),
        _c(
          "b-button",
          {
            attrs: { variant: "outline-secondary", size: "sm" },
            on: {
              click: function ($event) {
                return _vm.$emit("info", _vm.participation)
              },
            },
          },
          [
            _c("feather-icon", {
              staticClass: "mr-50",
              attrs: { icon: "InfoIcon", size: "14" },
            }),
            _vm._v(" " + _vm._s(_vm.$t("influencer_panel.info_button")) + " "),
          ],
          1
        ),
        _vm.participation.status === "AC"
          ? _c(
              "b-button",
              {
                staticClass: "ml-auto",
                attrs: { variant: "flat-danger", size: "sm" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("leave", _vm.participation)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("influencer_panel.leave")) + " ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }